import { render, staticRenderFns } from "./ques4.vue?vue&type=template&id=4c97f5d4"
import script from "./ques4.vue?vue&type=script&lang=js"
export * from "./ques4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports